/**
 * @module
 */
var addLazyProperty = require('lazy-property');

var actionTypes = require('core/constants/action_types');
var Flux = require('core/flux');
var Logger = require('core/utils/logger');

/**
 * Define a [lazy-property](https://www.npmjs.com/package/lazy-property) on `obj`. As a side effect, records the get in RUM.
 *
 * @param {Object} obj Object to define the property on
 * @param {string} propertyName Name of property
 * @param {Function} getter Function which returns the value of the property
 * @param {string} objName Name of the object (for metric tracking purposes)
 * @param {string} [overridePropMetricName] Name of the property (for metric tracking purposes). If not specified, will use propertyName in metric
 */
exports.defineProperty = function(obj:any, propertyName:string, getter:Function, objName:string, overridePropMetricName?:string) {
  addLazyProperty(obj, propertyName, function() {
    var metricName = ['prop', objName, overridePropMetricName || propertyName].join('.');
    Logger.debug('Evaluating getter: "' + metricName + '"');
    Flux.dispatch(actionTypes.RECORD_API_USAGE, {
      methodName: metricName,
    });
    return getter();
  }, true);
};
